import { Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CncReport } from '@gameonly/core';

import DoneAllIcon from '@mui/icons-material/DoneAll';
import { YellowButton } from '../ui/Button';
import ValidateReportModal from './ValidateReportModal';

const ValidateReport = ({ report }: { report: CncReport }) => {
  const [openValidate, setOpenValidate] = useState<boolean>(false);
  const { t } = useTranslation(['project']);

  const isValidated = !!report.validatedAt;
  const isCompleted = report.isInformationComplete && report.locals.length > 0;

  const handleValidateReport = (event: React.MouseEvent<HTMLElement>) => {
    if (!isCompleted) {
      return;
    }
    setOpenValidate(true);
  };

  const tooltipText = isCompleted
    ? t('project:validate-button.tooltip')
    : t('project:validate-button-disabled.tooltip');

  return (
    <>
      {!isValidated && (
        <Tooltip title={tooltipText}>
          <div>
            <YellowButton
              onClick={handleValidateReport}
              startIcon={<DoneAllIcon />}
              disabled={!isCompleted}
            >
              {t('project:validate-button.label')}
            </YellowButton>
          </div>
        </Tooltip>
      )}
      {openValidate && (
        <ValidateReportModal
          open={openValidate}
          onClose={() => setOpenValidate(false)}
        />
      )}
    </>
  );
};

export default ValidateReport;
